import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconSearch = styled.img.attrs({
  src: "/assets/images/icon-search.svg",
  title: "Search"
})`
  height: ${ICON_HEIGHT}px;
`;
IconSearch.displayName = "IconSearch";

export default IconSearch;
